import React, { useState, useEffect } from "react";
import {
  Type,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogTitleActions,
  DialogScroll
} from "discover.medical.react-component-library";
import { termsOfUseLink } from "../../shared/constants";
import "./index.css";
import axios from "axios";
import showdown from "showdown";

const FETCH_FAILED_MSG = "Unable to fetch the terms of use, please try again.";

const TermsOfUse = ({ isDlgOpen, onClose, resourceUrl }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [policyText, setPolicyText] = useState(FETCH_FAILED_MSG);

  const closeTermsOfUseModal = () => {
    setIsOpen(false);
    onClose();
  };

  useEffect(() => {
    setIsOpen(isDlgOpen);
    if (isDlgOpen) {
      axios.get(`${resourceUrl}/${termsOfUseLink}`)
        .then((res) => setPolicyText(res.data))
        .catch(() => setPolicyText(FETCH_FAILED_MSG));
    }
  }, [isDlgOpen, resourceUrl]);

  return (
    <div data-testid="terms-dialog">
      <Dialog
        aria-labelledby="scrollable-dialog-title"
        isOpen={isOpen}
        maxWidth="md"
        onRequestClose={closeTermsOfUseModal}
        data-testid="terms_and_conditions_dlg"
      >
        <DialogTitle>
          <Type element="h3" id="scrollable-dialog-title">
          Terms of Use
          </Type>
          <DialogTitleActions onRequestClose={closeTermsOfUseModal} />
        </DialogTitle>
        <DialogScroll style={{ maxHeight: "78vh" }}>
          <Card
            borderYColor="gray300"
            borderYStyle="solid"
            borderYWidth="1px"
          >
            <CardContent>
              <Type element="p">
              <div className="Terms__markdown" data-testid="terms_policy"
                  dangerouslySetInnerHTML={{
                    __html: new showdown.Converter({}).makeHtml(policyText)
                  }}
                />
              </Type>
            </CardContent>
          </Card>
        </DialogScroll>
        <div className="Form__button-wrap_close">
          <Button
            id="close_button"
            className="Form__button__close"
            type="button"
            onClick={closeTermsOfUseModal}
            data-testid="terms_and_conditions_close_dlg"
          >
            Close
          </Button>
        </div>
      </Dialog>
    </div>
  );
}

export default TermsOfUse;
